import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Input, Button, message, Slider } from "antd";
import { useTranslation } from "react-i18next";

import { actionCreators } from "@/duck/panel";
import { actionCreators as dashboardActionCreators } from "@/duck/dashboard";
import {
  selectDrawPolygon,
  selectVertex,
  selectOperationStatus,
} from "@/selector";
import { center } from "@/util";
import "@/components/dashboard/misc/CenterSelector.less";

const marks = {
  400: "400",
  700: "700",
  1000: "1000",
  1300: "1300",
  1600: "1600",
};

const CenterSelector = () => {
  const { t } = useTranslation();
  const { innerWidth } = window;
  const fontSize = innerWidth > 4000 ? 24 : 14;
  const vertex = useSelector(selectVertex);
  const [fields, setFields] = useState();

  const isDrawing = useSelector(selectDrawPolygon);
  const operationStatus = useSelector(selectOperationStatus);
  const dispatch = useDispatch();
  useEffect(() => {
    setFields(center(vertex));
  }, [vertex]);
  useEffect(() => {
    if (operationStatus === "fullfill") {
      message.warning(
        {
          content: t("order.fullfill"),
          style: {
            fontSize: fontSize,
          },
        },
        10,
        () => {
          dispatch(actionCreators.panel.operation.status({ status: null }));
        }
      );
    }
    if (operationStatus === "success") {
      message.warning(
        {
          content: t("order.success"),
          style: {
            fontSize: fontSize,
          },
        },
        10,
        () => {
          dispatch(actionCreators.panel.operation.status({ status: null }));
        }
      );
    }
  }, [operationStatus, dispatch, fontSize, t]);
  const toggleDrawing = useCallback(() => {
    dispatch(actionCreators.panel.draw.toggle());
  }, [dispatch]);
  const submitCompute = useCallback(
    (values) => {
      console.log(values);
      if (operationStatus === "loading" || operationStatus === "fullfill")
        return;
      dispatch(
        dashboardActionCreators.dashboard.panel.query.operation({
          point: [values.longitude, values.latitude],
          size: values.size,
        })
      );
    },
    [dispatch, operationStatus]
  );
  const onChange = useCallback(
    (newFields) => {
      setFields(newFields);
    },
    [setFields]
  );
  const updateLayers = useCallback(
    (n) => {
      const names = {
        20190515: "FY3D_MERSI_GBAL_L1_20190515_0320_0250M_MS",
        20190622: "FY3D_MERSI_GBAL_L1_20190622_0440_0250M_MS",
        20190715: "FY3D_MERSI_GBAL_L1_20190715_0405_0250M_MS",
        20190808: "FY3D_MERSI_GBAL_L1_20190808_0310_0250M_MS",
        20190915: "FY3D_MERSI_GBAL_L1_20190915_0615_0250M_MS",
      };
      const name = names[n] || "FY3D_MERSI_GBAL_L1_20190515_0320_0250M_MS";
      dispatch(
        actionCreators.panel.layer.update({
          currentLayerGroup: "remote",
          layers: [
            {
              name: `arctic:${name}`,
              type: "wms",
              url: "/geoserver/arctic/wms",
            },
          ],
        })
      );
    },
    [dispatch]
  );

  const toggleLayer = useCallback(
    (name) => {
      dispatch(actionCreators.panel.group.toggle({ name }));
    },
    [dispatch]
  );

  return (
    <div>
      <Form
        name="complex-form"
        onFinish={submitCompute}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        fields={fields}
        onFieldsChange={(changedFields, allFields) => {
          onChange(allFields);
        }}
        initialValues={{ size: 800 }}
      >
        <Form.Item label={t("order.lng")}>
          <Form.Item
            name="longitude"
            noStyle
            rules={[{ required: true, message: t("order.lngMssage") }]}
          >
            <Input placeholder={t("order.lngInput")} />
          </Form.Item>
        </Form.Item>
        <Form.Item label={t("order.lat")}>
          <Form.Item
            name="latitude"
            noStyle
            rules={[{ required: true, message: t("order.latMessage") }]}
          >
            <Input placeholder={t("order.latInput")} />
          </Form.Item>
        </Form.Item>
        <Form.Item label={t("order.resultRange")}>
          <Form.Item name="size" noStyle>
            <Slider
              min={400}
              max={1600}
              step={100}
              marks={marks}
              included={false}
              style={{ margin: "0 10px" }}
            />
          </Form.Item>
        </Form.Item>
        <Form.Item label=" " colon={false}>
          <Button type="primary" htmlType="submit">
            {operationStatus === "loading"
              ? t("order.loading")
              : t("order.submit")}
          </Button>
          <Button
            htmlType="button"
            style={{ margin: "0 8px" }}
            onClick={() => toggleDrawing()}
          >
            {isDrawing ? t("order.cancel") : t("order.map")}
          </Button>
        </Form.Item>
      </Form>
      <div>
        <Button type="link" onClick={() => updateLayers("20190515")}>
          2020-05-15
        </Button>
        <Button type="link" onClick={() => updateLayers("20190622")}>
          2020-06-22
        </Button>
        <Button type="link" onClick={() => updateLayers("20190715")}>
          2020-07-15
        </Button>
        <Button type="link" onClick={() => updateLayers("20190808")}>
          2020-08-08
        </Button>
        <Button type="link" onClick={() => updateLayers("20190915")}>
          2020-09-15
        </Button>
        <Button type="link" onClick={() => toggleLayer("remote")}>
          {t("order.clean")}
        </Button>
      </div>
    </div>
  );
};

export default CenterSelector;
